<!-- Botón para abrir el diálogo de búsqueda -->
<button pButton type="button" icon="pi pi-search" (click)="showDialog()" class="p-button-secondary"></button>

<!-- Diálogo (Popup) de Búsqueda de Clientes -->
<p-dialog header="Buscar Cliente" [(visible)]="display" [modal]="true" appendTo="body" [baseZIndex]="2000"
          [style]="{width: '590px', 'max-height': '90vh' }" 
          [maximizable]="false" [draggable]="false" [resizable]="false"
          (onHide)="closeDialog()" [contentStyle]="{'padding': '0.5rem', 'overflow-y': 'auto'}">

  <!-- Filtros de Búsqueda -->
  <div class="p-fluid p-formgrid grid m-0">
    <div class="p-field col-12 py-1">
      <label for="nombre" style="font-size: 0.75rem; font-weight: bold; margin-bottom: 2px;">Nombre</label>
      <input id="nombre" type="text" pInputText [(ngModel)]="filterNombre" (keyup.enter)="search()" class="p-inputtext-sm">
    </div>
    <div class="p-field col-12 md:col-8 py-1">
      <label for="ruc" style="font-size: 0.75rem; font-weight: bold; margin-bottom: 2px;">RUC / Cédula</label>
      <input id="ruc" type="text" pInputText [(ngModel)]="filterRuc" (keyup.enter)="search()" class="p-inputtext-sm">
    </div>
    <div class="p-field col-12 md:col-4 py-1">
        <label>&nbsp;</label>
        <button pButton type="button" label="Buscar" icon="pi pi-search" (click)="search()" class="p-button-sm"></button>
    </div>
  </div>

  <!-- Tabla de Resultados con Paginación -->
  <div class="mt-2" style="font-size: 0.75rem;">
    <p-table [value]="clientes" [lazy]="true" (onLazyLoad)="loadCustomersLazy($event)" [paginator]="true"
             [rows]="5" [totalRecords]="totalRecords" [loading]="loading"
             [showCurrentPageReport]="false"
             [rowsPerPageOptions]="[5, 10]" styleClass="p-datatable-sm p-datatable-striped custom-compact-table">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 15%; font-size: 0.75rem;">ID</th>
          <th style="width: 30%; font-size: 0.75rem;">Nombre</th>
          <th style="width: 29%; font-size: 0.75rem;">Dirección</th>
          <th style="width: 16%; font-size: 0.75rem;">RUC</th>
          <th style="width: 10%; text-align: center; font-size: 0.75rem;">Acción</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-cliente>
        <tr>
          <td style="font-size: 0.7rem; padding: 0.25rem !important;">{{ cliente.idCliente }}</td>
          <td style="font-size: 0.7rem; padding: 0.25rem !important;">{{ cliente.nombreCliente1 }}</td>
          <td style="font-size: 0.7rem; padding: 0.25rem !important;">{{ cliente.poblacion }} - {{ cliente.direccion }}</td>
          <td style="font-size: 0.7rem; padding: 0.25rem !important;">{{ cliente.ruc }}</td>
          <td style="text-align: center; padding: 0.25rem !important;">
            <button pButton type="button" icon="pi pi-check" class="p-button-rounded p-button-success p-button-sm"
                    style="width: 1.5rem; height: 1.5rem;"
                    (click)="selectCliente(cliente)"></button>
          </td>
        </tr>
      </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align: center;">No se encontraron clientes. Realice una búsqueda.</td>
        </tr>
    </ng-template>
  </p-table>
  </div>
</p-dialog>
